import { AppstoreAddOutlined } from '@ant-design/icons';
import { getArrayWidgetReference } from '../../../../expressions/references/builder/getArrayWidgetReference.ts';
import { RepeatableRangeRule } from '../../../../rules/repository/repeatable-range/RepeatableRange.rule.ts';
import { UniqueFieldRule } from '../../../../rules/repository/unique-field-rule/UniqueFieldRule.rule.ts';
import { tran } from '../../../../translations/schema/TranslationSchema.ts';
import { type IWidgetType } from '../../../IWidgetType.ts';
import { WidgetCategory, WidgetMainType, WidgetType } from '../../../Widget.ts';
import { createRepeatableSchema } from './createRepeatableSchema.ts';
import { hydrateRepeatableWidget } from './hydrateRepeatableWidget.ts';
import { type IRepeatableWidget } from './IRepeatableWidget.ts';
import { RepeatableWidgetComponent } from './RepeatableWidgetComponent.tsx';
import { RepeatableWidgetConfigComponent } from './RepeatableWidgetConfigComponent.tsx';
import { RepeatableWidgetConfigSchema } from './RepeatableWidgetConfigSchema.ts';
import { RepeatableWidgetPreview } from './RepeatableWidgetPreview.tsx';

/**
 * Tipo del componente  contenitore di una lista ripetibile di Widget.
 */
export const RepeatableWidgetType: IWidgetType<IRepeatableWidget> = {
  type: WidgetType.Repeatable,
  mainType: WidgetMainType.Container,
  category: WidgetCategory.Advanced,
  name: 'Lista Ripetibile',
  icon: <AppstoreAddOutlined rotate={-90} />,
  hasValue: true,
  getReference: getArrayWidgetReference,
  formComponent: RepeatableWidgetComponent,
  hydrate: hydrateRepeatableWidget,
  createFormSchema: createRepeatableSchema,
  configComponent: RepeatableWidgetConfigComponent,
  configValidator: RepeatableWidgetConfigSchema,
  previewComponent: RepeatableWidgetPreview,
  translationSchema: tran.widget({
    description: tran.rte(),
    layout: tran.object({
      buttonText: tran.string(),
    }),
    rules: tran.rules(),
  }),
  rules: [RepeatableRangeRule, UniqueFieldRule],
};
